import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FullScreen, useFullScreenHandle } from 'react-full-screen';
import MyMap from './components/MyMap';
import { isMobile } from 'react-device-detect';

export default function App() {
  const [skipSplash, setSkipSplash] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);
  const [isHorizontal, setIsHorizontal] = useState(
    window.innerWidth > window.innerHeight
  );
  const [mintingOverride, setMintingOverride] = useState(false);
  const [showVersionToggle, setShowVersionToggle] = useState(false);

  useEffect(() => {
    const handleOrientationChange = () => {
      setIsHorizontal(window.innerWidth > window.innerHeight);
    };

    window.addEventListener('resize', handleOrientationChange);

    // cleanup function
    return () => {
      window.removeEventListener('resize', handleOrientationChange);
    };
  }, []);

  useEffect(() => {
    const loadMobileCSS = async () => {
      if (isMobile) {
        await import('./styles/topbar_mobile.css');
      }
    };
    loadMobileCSS();
  }, []);

  const handle = useFullScreenHandle();

  function validateInput(input) {
    if (input === 'info') {
      return true;
    }

    let parts = input.split('.');

    if (parts.length > 2) {
      return false;
    }

    let X = parts[0];
    let Y = parts[1];

    if (X == 'info') {
      return true;
    }

    if (
      isNaN(X) ||
      parseInt(X) > 999 ||
      parseInt(X) < 0 ||
      X.length > 4 ||
      X.length < 1
    ) {
      return false;
    }

    if (
      Y !== undefined &&
      (isNaN(Y) || Y.length !== 4 || parseInt(Y) > 5226 || parseInt(Y) < 0)
    ) {
      return false;
    }

    var urlId = '/todem/' + X.toString().padStart(4, '0');
    if (Y !== undefined) {
      urlId = urlId + '.' + Y.toString();
    }
    window.history.pushState('', '', '' + urlId);

    return true;
  }

  function runTests() {
    const tests = [
      // Valid cases
      { input: 'info', expected: true },
      { input: 'info.nav', expected: true },

      { input: '000', expected: true },
      { input: '0000', expected: true },
      { input: '0000.0000', expected: true },
      { input: '000.0000', expected: true },
      { input: '123', expected: true },
      { input: '100.0000', expected: true },
      { input: '999.0001', expected: true },
      { input: '0999.0001', expected: true },
      { input: '0999.5226', expected: true },

      // Invalid cases
      { input: '1000', expected: false },
      { input: '999.', expected: false },
      { input: '9999', expected: false },
      { input: '123.123', expected: false },
      { input: '1234.0000', expected: false },
      { input: '999.10000', expected: false },
      { input: '00999.1000', expected: false },
      { input: '', expected: false },
      { input: 'word', expected: false },
    ];

    for (let test of tests) {
      const result = validateInput(test.input);
      if (result !== test.expected) {
        console.log(`Test failed for input ${test.input}`);
        return;
      }
    }

    console.log('All tests passed!');
  }

  async function initializeApp() {
    const wasReload = window.performance
      .getEntriesByType('navigation')
      .map((nav) => nav.type)
      .includes('reload');

    if (wasReload) {
      var urlId = '/todem/';
      window.history.pushState('', '', '' + urlId);
      setIsInitialized(true);
      return;
    }

    let search = window.location.search;
    let params = new URLSearchParams(search);

    let version_toggle = params.get('vt');
    if (version_toggle) {
      setShowVersionToggle(version_toggle);
    }

    let affiliate = params.get('a');
    if (affiliate) {
      localStorage.setItem('affiliate', affiliate);
      let clean_url =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname;
      window.history.replaceState({}, document.title, clean_url);
      console.log('affiliate', affiliate);
    }
    let minting_override = params.get('mp');
    if (minting_override == 1) {
      setMintingOverride(true);
    }
    let art_experience = params.get('ae');
    if (art_experience == 1) {
      localStorage.setItem('art_experience', 'true');
    } else if (art_experience == 0) {
      localStorage.setItem('art_experience', 'false');
    }

    var currentUrl = window.location.href;
    var tileUrl = currentUrl.split('/');

    if (tileUrl[tileUrl.length - 1] === '') {
      tileUrl.pop();
    }
    if (
      tileUrl[tileUrl.length - 2] === 'todem' &&
      validateInput(tileUrl[tileUrl.length - 1])
    ) {
      setSkipSplash(true);
      setIsInitialized(true);
    } else {
      var urlId = '/todem/';
      window.history.pushState('', '', '' + urlId);
    }

    setIsInitialized(true);
    return;
  }

  useEffect(() => {
    initializeApp();
  }, []);

  return (
    <div className="App">
      <FullScreen handle={handle}>
        {isHorizontal && isMobile && (
          <div className="horizontal-banner">
            {' '}
            We do not support landscape view on mobile.
          </div>
        )}
        {isInitialized && (
          <MyMap
            handle={handle}
            skipSplash={skipSplash}
            mintingOverride={mintingOverride}
            showVersionToggle={showVersionToggle}
          />
        )}
      </FullScreen>
    </div>
  );
}
